import React, { useState, useEffect, useRef } from 'react';
import { Box, Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import { history, useLocation } from 'umi';
import Alert from '@material-ui/core/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import BasicSetting from './components/BasicML';
import TitleML from './components/TitleML';
import LabelRules from './components/label_rules';
import CrowdImportStyled from './CrowdImportStyled';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import Loading from '@/components/LoadingML/LoadingML';
import webStorage from '@/utils/storageManager';

const CreateLabel = () => {
  const location = useLocation();
  // 用户菜单权限
  const userAuths = webStorage.get('USER')?.authorities;
  const { query } = location;
  const queryType = query?.opt; //编辑 详情 string
  const tagId = query.tagId ? Number(query.tagId) : null; //标签id int
  const dispatch = useDispatch();
  const submitRef = useRef();
  const [disabledConfirm, setDisabledConfirm] = useState(true);
  const [saveOpen, setSaveOpen] = useState({
    tips: '',
    status: false,
    title: '',
  });
  const {
    handleSubmit,
    control,
    errors,
    getValues,
    setValue,
    clearErrors,
    setError,
    // formState: { isSubmitted },
  } = useForm();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['crowdImport/queryTagAndRule'];
  const submitLoading =
    loadingEffect.effects['crowdImport/insertOrUpdateTagAndRule'];
  //外部导入文件list
  const [fileList, setFileList] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  //显示确定提示弹窗
  const handleSubmitDialog = () => {
    setSaveOpen({
      status: true,
      tips: '确认保存当前所创建的内容？',
      title: '保存',
    });
  };

  // 退出
  const handleSignOut = () => {
    if (queryType === 'detail') {
      history.goBack();
      return;
    }
    setSaveOpen({
      status: true,
      tips: '退出后将不保存设置内容，确定要退出吗？',
      title: '退出',
    });
  };

  // 详情数据赋值
  useEffect(() => {
    setValue('updateStrategy', '1');
    !tagId && setValue('importId', '1');
  }, [setValue, tagId]);
  //人群导入字段配置
  useEffect(() => {
    dispatch({
      type: 'crowdImport/queryGroupImportConfigList',
      payload: {
        values: {
          importType: 2,
        },
      },
      callback: () => {},
    });
  }, [dispatch, setValue]);

  //按钮防抖
  const onSubmitError = () => {
    setDisabledConfirm(true);
    window.message.toast({
      type: 'error',
      message: '输入有误',
    });
  };

  // 创建
  const onSubmitSuccess = (data) => {
    console.log({ disabledConfirm });
    if (!disabledConfirm) {
      return;
    }
    setDisabledConfirm(false);
    const postData = {
      id: tagId,
      title: data.title,
      updateStrategy: Number(data.updateStrategy),
      remark: data.remark,
      importId: data.importId,
      fileUri: fileList[0].url,
      fileName: fileList[0].fileName,
      type: 3,
      isLimitNumberDownload: false,
    };
    window.NE_DAWN.trigger(submitRef.current, {
      event: '_ec', // 事件名
      params: { ...postData }, // 事件公参
    });
    dispatch({
      type: 'crowdImport/insertOrUpdateGroupAndRule',
      payload: {
        values: postData,
      },
      callback: (code) => {
        if (code === 0) {
          setAlertOpen(true);
          setTimeout(() => history.goBack(), 3000);
        }
        console.log('res', code === 0);
        setDisabledConfirm(true);
      },
    });
  };

  useEffect(() => {
    if (tagId) {
      dispatch({
        type: 'crowdCreateCopy/queryTagAndRule',
        payload: {
          values: {
            groupId: tagId,
          },
        },
        callback: (data) => {
          setValue('title', data.title);
          setValue('remark', data.remark);
          setValue('importId', String(data.importId));
          setValue('url', data.fileUri);
          data.fileUri &&
            setFileList([
              { url: data.fileUri, id: data.id, fileName: data.fileName },
            ]);
        },
      });
    }
  }, []);

  //新建标签自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseDialog}
          color="secondary"
        >
          取消
        </Button>
        <Button
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={onSaveLabelDialog}
        >
          确定
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  const onSaveLabelDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
    if (saveOpen.title === '保存') {
      submitRef.current.click();
    } else if (saveOpen.title === '退出') {
      history.goBack();
    } else {
      dispatch({
        type: 'crowdCreateCopy/deleteLabel',
        payload: {
          values: {
            groupId: tagId,
          },
        },
        callback(res) {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '删除成功',
              title: '删除成功',
            });
            setTimeout(() => {
              history.goBack();
            }, 2000);
          }
        },
      });
    }
  };

  const onCloseDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
  };

  const handleClose = () => {
    setAlertOpen(false);
  };

  const handleDelete = () => {
    setSaveOpen({
      status: true,
      tips: `确认删除“${getValues('title')}”标签？删除后将无法复原。`,
      title: '删除',
    });
  };

  return (
    <CrowdImportStyled>
      <Loading loading={loading || submitLoading}>
        <Box
          data-log={JSON.stringify({
            oid: 'page_user_profile_management_edit',
            isPage: true,
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
            events: ['_pv', '_pd'],
          })}
        >
          <form onSubmit={handleSubmit(onSubmitSuccess, onSubmitError)}>
            <Box borderRadius="12px" bgcolor="background.paper" p={4}>
              <TitleML title="人群基本设置" fontSize="19px" p="0 0 32px 0" />
              <BasicSetting
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                setError={setError}
                clearErrors={clearErrors}
              />
            </Box>
            <Box
              borderRadius="12px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
            >
              <TitleML title="人群规则设置" fontSize="19px" p="0" />
              <LabelRules
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                setError={setError}
                clearErrors={clearErrors}
                fileList={fileList}
                setFileList={setFileList}
              />
            </Box>
            <Box
              borderRadius="4px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
              display="flex"
              alignItems="center"
            >
              {queryType !== 'detail' && (
                <Button
                  variant="contained"
                  // type="submit"
                  onClick={handleSubmitDialog}
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  sx={{ marginRight: '16px' }}
                  // disabled={disabledConfirm}
                >
                  保存
                </Button>
              )}
              {queryType === 'edit' && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_management_edit_delete',
                    events: ['_ev', '_ec'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  style={{
                    marginRight: '15px',
                    backgroundColor:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#CA2C21'
                        : '#F5F5F5',
                    color:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#fff'
                        : '#ccc',
                  }}
                  variant="contained"
                  className="cancel"
                  startIcon={
                    <DeleteIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={
                    userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1 &&
                    handleDelete
                  }
                >
                  删除
                </Button>
              )}
              <Button
                style={{
                  marginRight: '15px',
                  backgroundColor: '#212121',
                  color: '#fff',
                }}
                variant="contained"
                color="secondary"
                className="cancel"
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
                onClick={handleSignOut}
              >
                退出
              </Button>
              <Button
                data-log={JSON.stringify({
                  oid: 'btn_user_profile_management_edit_save',
                  events: ['_ev'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                  },
                })}
                sx={{ display: 'none' }}
                type="submit"
                ref={submitRef}
              ></Button>
            </Box>
          </form>
          <DialogDataML
            open={saveOpen.status}
            title={
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <span
                  style={{
                    fontSize: '18px',
                    fontWeight: 600,
                    color: '#212121',
                  }}
                >
                  {saveOpen.title}
                </span>
              </Box>
            }
            content={<Box sx={{ width: '336px' }}>{saveOpen.tips}</Box>}
            handleClose={onCloseDialog}
            button={initButton()}
          />
        </Box>
      </Loading>
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          人群包上传中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </CrowdImportStyled>
  );
};

export default CreateLabel;
